<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/tiposala"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.descricaotiposalaescola }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :submit="onSubmit"
      :acao="acao"
      :novo="novoTipoDeSala"
      :editar="editarTipoDeSala"
      :excluir="excluirTipoDeSala"
      :cancelar="cancelarTipoDeSala"
      :id="form.identificadortiposalaescola"
      class="mb-3">
    <!-- *******  -->
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaTipoSala">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
    <!-- *******  -->

      <v-card class="pa-3">
        <Input type="text" label="Código Tipo Sala" disabled v-model="form.identificadortiposalaescola" />
        <Input type="text" ref="focusCampo" label="Descrição do Tipo de Sala " :disabled="acao == ''" v-model="form.descricaotiposalaescola" :v="$v.form.descricaotiposalaescola"/>
      </v-card>
    </FormBasico>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api';
import Input from '@/components/Input';
import Select from '@/components/Select';
import FormBasico from '@/components/FormBasico';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadortiposalaescola: '',
  descricaotiposalaescola: '',

});

export default {
  name: 'TipoSala',
  components: {
    Input,
    Select,
    FormBasico,
    BuscaSimplesApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      msgError: '',
      msgArrayError: [],
      snackbar: false,
      submitText: '',
      formUltimo: {},
      buscarSelect: 'descricaotiposalaescola',
      buscaOptions: [
        { value: 'identificadortiposalaescola', text: 'Código Tipo de Sala' },
        { value: 'descricaotiposalaescola', text: 'Tipo de Sala' },
      ],
    };
  },
  validations() {
    return {
      form: {
        descricaotiposalaescola: {
          required, minLength: minLength(5), maxLength: maxLength(100), alphaSpace,
        },
      },
      /*   GAMBIARRA
           A regra de validação abaixo foi inserida apenas para corrigir um pequeno erro na interface de usuário que ocorre quando o botão cancelar é usado.

           Quando a última regra de validação declarada não é válida, a validação impede que o botão cancelar seja executado.
           Porém, quando a última regra é válida, o erro não ocorre.
           Nesse caso, como nesta tela só há um campo sendo validado e ele não está válido quando o botão cancelar é clicado,
           é necessário lançar uma regra vazia abaixo somente para evitar de o erro ocorrer.
      */
      submitText: {}
    };
  },
  methods: {
    //*************    */
    tabelaTipoSala(){
      this.$root.$router.push({
          name: 'tabelas',
          params: {
            titulo: 'Tipo de Sala / Listar',
            rota_api: 'gerencial/tiposala/tabela',
            headers: [{ text: 'Identificador', value: 'identificadortiposalaescola', filtable: true, sortable: false},
						          { text: 'Descrição', value: 'descricaotiposalaescola', filtable: true, sortable: false}]
          }
      });
    },
//*************** */
    novoTipoDeSala() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarTipoDeSala() {
      if (this.form.identificadortiposalaescola !== '') {
        this.acao = 'editar';
      }
    },
    async excluirTipoDeSala() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este tipo de sala?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/tiposala/${this.form.identificadortiposalaescola}`);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
    cancelarTipoDeSala() {
      if (this.acao === 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }
      api({
        method: (this.acao === 'novo') ? 'post' : 'put',
        url: `gerencial/tiposala${(this.acao === 'novo') ? '' : `/${this.form.identificadortiposalaescola}`}`,
        data: this.form,
      }).then((response) => {
        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
      }).catch((error) => {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
    },
    encontrado(dados) {
      console.log(dados);
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
  },
};
</script>

<style lang="scss">
.escola-card-dados{
  display: block;
  padding: 10px 16px;

  .escola-card-dados-itens{
    display: flex;
    div{
      flex: 1
    }
  }
}
</style>
